import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding-bottom: 5%;
  svg path {
    fill: ${({ theme }) => theme.colors.text.main};
  }
`;

export const DotList = styled.div`
  margin-top: 16px;

  & > div {
    display: inline-block;
    width: 8px;
    height: 8px;
    margin: 0 2.5px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.gray4};
    animation: 0.6s ease-out;
    transform: translate3d(0, 0, 0);
    transition: transform 0.6s ease-out;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
  }
`;
